var React = require('react');

function ArrowBack (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.3758 18.4244C10.6101 18.6587 10.99 18.6587 11.2243 18.4244C11.4586 18.19 11.4586 17.8101 11.2243 17.5758L6.24945 12.601L19.2 12.601C19.5314 12.601 19.8 12.3323 19.8 12.001C19.8 11.6696 19.5314 11.401 19.2 11.401L6.2477 11.401L11.2243 6.42436C11.4586 6.19005 11.4586 5.81015 11.2243 5.57583C10.99 5.34152 10.6101 5.34152 10.3758 5.57583L4.37578 11.5758C4.14147 11.8101 4.14147 12.19 4.37578 12.4244L10.3758 18.4244Z","fill":"#677574"}));
}

ArrowBack.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowBack;

ArrowBack.default = ArrowBack;
